import { useTranslation } from "react-i18next";
import { TbRecycle } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useUsersTableActions, useUsersUpdateLifeCycleDialog } from "@/stores/use-users-table";

import UpdateLifeCycleDialog from "./UpdateLifeCycleDialog";

function UpdateUserLifeCycleComp() {
    const { t } = useTranslation();
    const { updateShowUpdateUserLifeCycleDialog } = useUsersTableActions();
    const onClose = () => {
        updateShowUpdateUserLifeCycleDialog();
    };
    const showUpdateUserLifeCycleDialog = useUsersUpdateLifeCycleDialog();

    return (
        <CommonPopup
            title={t("buttons.updateUserLifeCycle")}
            icon={TbRecycle}
            open={!!showUpdateUserLifeCycleDialog}
            size="sm"
            onClose={onClose}
        >
            <UpdateLifeCycleDialog />
        </CommonPopup>
    );
}

export default UpdateUserLifeCycleComp;
